import { AnySchema, ValidationResult, ValidationErrorItem } from '@hapi/joi';

export function validate<T>(model: T, schema: AnySchema): ValidationResult {
  return schema.validate(model, {
    abortEarly: false,
  });
}


export function formatValidationMessages(arr: ValidationErrorItem[]): string[] {
  const seen = new Set<string>();
  const formattedMessagesArray: string[] = [];

  arr.forEach((err: ValidationErrorItem) => {
    const msg = err.message;
    if (!seen.has(msg)) {
      seen.add(msg);
      formattedMessagesArray.push(msg);
    }
  });

  return formattedMessagesArray;
}

export function mapValidationErrors(
  errors: ValidationErrorItem[]
): Record<string, string> {
  const map: Record<string, string> = {};

  errors.forEach((e) => {
    const key = e.path?.[e.path.length - 1];

    if (!key) return;

    // only keep first error per field
    if (!map[key]) {
      map[key] = e.message;
    }
  });

  return map;
}
